export default __webpack_public_path__ + "static/media/NOTO_SANS_KR.42930f57.ttf";